import { useState, useEffect } from 'react';
import R4c3 from './LayoutsChart/43';
import R3c3 from './LayoutsChart/33';
import R2c2 from './LayoutsChart/22';

function Realtime() {
    // กำหนดค่าเริ่มต้นให้เป็น 4x3 (R4c3) ทันทีที่เปิดหน้าเว็บ
    const [selectedValue, setSelectedValue] = useState('R4c3');
    // const [selectedValue, setSelectedValue] = useState('R2c2');
    const [selectedLayout, setSelectedLayout] = useState(<R4c3 />);

    useEffect(() => {
        if (selectedValue === 'R4c3') {
            setSelectedLayout(<R4c3 />);
        } else if (selectedValue === 'R3c3') {
            setSelectedLayout(<R3c3 />);
        } else if (selectedValue === 'R2c2') {
            setSelectedLayout(<R2c2 />);
        } else {
            setSelectedLayout(null);
        }
    }, [selectedValue]);

    return (
        <div className="w-full min-h-screen bg-[#0b111a] text-white px-4 md:px-6 py-6">
            <div className="max-w-[1600px] mx-auto flex flex-col h-full">

                {/* ================= TOP CONTROL BAR (Style แบบ Flow Intraday) ================= */}
                <div className="flex flex-wrap items-center justify-between mb-6 gap-4">
                    
                    {/* Left: Layout Selector & Legend */}
                    <div className="flex flex-wrap items-center gap-4 md:gap-6">
                        
                        {/* Layout Selector */}
                        <div className="flex items-center gap-3 bg-[#111827] border border-slate-700 px-4 py-2 rounded-lg">
                            <span className="text-sm text-slate-400">Select Layout :</span>
                            <div className="flex gap-2">
                                {[
                                    { id: 'R4c3', icon: '▦' },
                                    { id: 'R3c3', icon: '▤' },
                                    { id: 'R2c2', icon: '☰' }
                                ].map((layout) => (
                                    <button
                                        key={layout.id}
                                        onClick={() => setSelectedValue(layout.id)}
                                        className={`w-7 h-7 rounded text-xs flex items-center justify-center transition
                                            ${selectedValue === layout.id 
                                                ? "bg-purple-600 text-white" 
                                                : "bg-[#1f2937] text-slate-400 hover:text-white"
                                            }`}
                                    >
                                        {layout.icon}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Legend Indicator */}
                        <div className="flex items-center gap-3 text-sm text-slate-400">
                            <span>Price</span>
                            <div className="w-8 h-[2px] bg-white rounded-full"></div>
                            <span className="ml-2">Value</span>
                            <div className="flex gap-1 flex-col justify-center h-full">
                                <div className="w-6 h-[2px] bg-green-400 rounded-full"></div>
                                <div className="w-6 h-[2px] bg-red-400 rounded-full"></div>
                            </div>
                        </div>
                    </div>

                
                </div>

                {/* ================= CHART CONTAINER ================= */}
                <div className="w-full h-[85vh] bg-[#0B1221] border border-slate-700/50 rounded-2xl overflow-y-auto overflow-x-hidden shadow-2xl p-2 md:p-4">
                    <div className="w-full h-full min-w-[1000px] flex flex-col">
                    {selectedLayout}
                    </div>
                </div>

            </div>
        </div>
    );
}

export default Realtime;